import { FC } from 'react';
import { Text, Heading } from '@/_components';
import type { ExpandedContentProps } from './ExpandedContent.types';
import type { IdentityVerificationStatus } from '@/_types/models/taxReturns';
import styles from './ExpandedContent.module.css';

const getColorByStatus = (status?: IdentityVerificationStatus | null) => {
  switch (status) {
    case 'failed':
      return 'critical';
    case 'verified':
      return undefined;
    default:
      return 'secondary';
  }
};

const getExpandedContentClass = (
  status?: IdentityVerificationStatus | null,
) => {
  const effectiveStatus = status || 'not_started';
  switch (effectiveStatus) {
    case 'failed':
      return styles.expandedContentCritical;
    case 'verified':
      return styles.expandedContentDefault;
    default:
      return styles.expandedContentAccent;
  }
};

export const ExpandedContent: FC<ExpandedContentProps> = ({
  status,
  heading,
  details,
}) => {
  const color = getColorByStatus(status);
  const contentClass = getExpandedContentClass(status);

  return (
    <div className={`${styles.expandedContent} ${contentClass}`}>
      <div className={styles.expandedContentInner}>
        <Heading level={6} color={color}>
          {heading}
        </Heading>
        <Text type="small">{details}</Text>
      </div>
    </div>
  );
};
